<template>
  <b-form class="px-2 mb-3">
    <b-row>
      <b-col lg="3">
        <span class="product-creation-section-labels py-0">
          Special Discount
        </span>
        <i class="base-tooltip" aria-hidden="true" v-b-popover.hover="'When enabled, this feature allows the product item to be marked down using special discounts.'"></i>
      </b-col>
      <b-col class="d-flex align-items-center" lg="5">
            <switches
              v-model="enable_special_discount"
              theme="custom"
              color="primary"
              type-bold="true"
              style="top: 12px; margin-right: 8px"
              :emit-on-mount="false"
            />
            <p class=" m-0" style="font-size: 14px;font-family: MainFontRegular, sans-serif;">
              Allow special discount/s
            </p>
            
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import Switches from "vue-switches";

export default {
    components: { Switches },
    computed: {
        ...mapFields("products", ["enable_special_discount"])
    }
};
</script>
